<div
  class="flex w-full items-center justify-center overflow-hidden rounded-xl bg-shikenso-gray-base-24"
  [style.aspect-ratio]="aspectRatio()"
>
  @if (objectUrl(); as url) {
    <button
      type="button"
      class="h-full w-full cursor-zoom-in"
      [attr.aria-label]="'pages.campaignDetails.ctaAnalytics.details.findingCards.enlargeImage' | translate"
      (click)="onEnlarge(url)"
    >
      <img class="h-full w-full object-contain" [src]="url" [alt]="alt()" (error)="onImageError()" />
    </button>
  } @else {
    <app-icon
      src="/icons/image-placeholder.svg"
      color="var(--shikenso-purple-base-40)"
      [alt]="'pages.campaignDetails.ctaAnalytics.details.findingCards.noImage' | translate"
      [size]="32"
    />
  }
</div>
